import ArrowsArrowRightUpLine from './arrows-arrow-right-up-line.component.js'

export * from './arrows-arrow-right-up-line.component.js'
export default ArrowsArrowRightUpLine

ArrowsArrowRightUpLine.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-icon-arrow-right-up-line': ArrowsArrowRightUpLine
  }
}
